export default __webpack_public_path__ + "static/media/Finance cirlce.9de46a25.svg";